interface IDividerIcon {
  width: number | string;
  height: number | string;
  color: string;
}

const DividerIcon = ({ width, height, color }: IDividerIcon) => {
  // rendering divider icon component here
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 95'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='border'
    >
      <line x1='29.5' y1='4' x2='29.5' y2='91' stroke={color} />
      <line
        y1='-0.5'
        x2='87'
        y2='-0.5'
        transform='matrix(4.37114e-08 1 1 -4.37114e-08 10.0242 4)'
        stroke={color}
      />
      <line x1='19.5' y1='4' x2='19.5' y2='91' stroke={color} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37 90.5C37 92.433 35.433 94 33.5 94C31.567 94 30 92.433 30 90.5C30 90.3302 30.0121 90.1633 30.0354 90H29.0275C29.0093 90.1642 29 90.331 29 90.5C29 92.9853 31.0147 95 33.5 95C35.9853 95 38 92.9853 38 90.5C38 90.331 37.9907 90.1642 37.9725 90H36.9646C36.9879 90.1633 37 90.3302 37 90.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.02417 90.5C2.02417 92.433 3.59117 94 5.52417 94C7.45717 94 9.02417 92.433 9.02417 90.5C9.02417 90.3302 9.01208 90.1633 8.98873 90H9.99671C10.0149 90.1642 10.0242 90.331 10.0242 90.5C10.0242 92.9853 8.00945 95 5.52417 95C3.03889 95 1.02417 92.9853 1.02417 90.5C1.02417 90.331 1.03349 90.1642 1.05163 90H2.05961C2.03626 90.1633 2.02417 90.3302 2.02417 90.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30 4.5C30 2.567 31.567 0.999999 33.5 1C35.433 1 37 2.567 37 4.5C37 4.66976 36.9879 4.8367 36.9646 5L37.9725 5C37.9907 4.83583 38 4.669 38 4.5C38 2.01472 35.9853 -1.76132e-07 33.5 -3.93402e-07C31.0147 -6.10673e-07 29 2.01472 29 4.5C29 4.669 29.0093 4.83583 29.0275 5L30.0354 5C30.0121 4.8367 30 4.66976 30 4.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.02417 4.5C9.02417 2.567 7.45717 0.999999 5.52417 1C3.59117 1 2.02417 2.567 2.02417 4.5C2.02417 4.66976 2.03626 4.8367 2.05961 5L1.05163 5C1.03349 4.83583 1.02417 4.669 1.02417 4.5C1.02417 2.01472 3.03889 -1.7613e-07 5.52417 -3.93401e-07C8.00945 -6.10671e-07 10.0242 2.01472 10.0242 4.5C10.0242 4.669 10.0149 4.83583 9.99671 5L8.98873 5C9.01208 4.8367 9.02417 4.66976 9.02417 4.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M34.2798 1.08693C36.1637 1.52005 37.3397 3.39833 36.9066 5.28217C36.4735 7.16602 34.5952 8.34207 32.7114 7.90894C32.5459 7.87091 32.3859 7.82172 32.232 7.76237L32.0062 8.74472C32.1621 8.79919 32.3226 8.84565 32.4873 8.88352C34.9094 9.44039 37.3243 7.92833 37.8812 5.50624C38.438 3.08415 36.926 0.669227 34.5039 0.112356C34.3392 0.0744872 34.1745 0.0461859 34.0105 0.0270875L33.7846 1.00944C33.949 1.02326 34.1144 1.04889 34.2798 1.08693Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.74434 1.08693C2.86049 1.52005 1.68445 3.39833 2.11757 5.28217C2.55069 7.16602 4.42897 8.34207 6.31282 7.90894C6.47826 7.87091 6.63824 7.82172 6.79216 7.76237L7.01802 8.74472C6.86209 8.79919 6.70159 8.84565 6.53688 8.88352C4.11479 9.44039 1.69987 7.92833 1.143 5.50624C0.586126 3.08415 2.09818 0.669227 4.52027 0.112356C4.68498 0.0744872 4.84966 0.0461859 5.01372 0.0270875L5.23957 1.00944C5.07519 1.02326 4.90979 1.04889 4.74434 1.08693Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32.607 87.0826C34.4741 86.5823 36.3933 87.6904 36.8936 89.5575C37.3939 91.4246 36.2859 93.3438 34.4187 93.8441C34.2547 93.8881 34.0904 93.9196 33.9266 93.9393L34.1875 94.9129C34.3507 94.888 34.5143 94.8538 34.6775 94.81C37.0781 94.1668 38.5028 91.6993 37.8595 89.2987C37.2163 86.8981 34.7488 85.4735 32.3482 86.1167C32.1849 86.1605 32.0262 86.2126 31.8723 86.2726L32.1332 87.2463C32.2849 87.1815 32.443 87.1266 32.607 87.0826Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.41718 87.0826C4.55005 86.5823 2.63087 87.6904 2.13057 89.5575C1.63028 91.4246 2.73831 93.3438 4.60545 93.8441C4.76942 93.8881 4.9338 93.9196 5.09758 93.9393L4.8367 94.9129C4.67343 94.888 4.50987 94.8538 4.34663 94.81C1.94603 94.1668 0.521408 91.6993 1.16465 89.2987C1.80788 86.8981 4.2754 85.4735 6.676 86.1167C6.83924 86.1605 6.99798 86.2126 7.15185 86.2726L6.89097 87.2463C6.73928 87.1815 6.58116 87.1266 6.41718 87.0826Z'
        fill={color}
      />
    </svg>
  );
};

export default DividerIcon;
